(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.ZUGAcrylicCartGuard = api;
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  var SOURCES = {
    7116075499583: 'pin',
    7118348058687: 'keychain',
    7191476011071: 'charm',
    8304492511295: 'magnet'
  };
  var CARRIERS = {
    8304287121471: 'pin',
    8304289120319: 'keychain',
    8304289906751: 'charm',
    8304493035583: 'magnet'
  };
  var CONFIGURED = 'native_configured_order_variant';
  var DYNAMIC = 'acrylic_exact_native_rate_units';
  var CONTRACT = 'zug_acrylic_commercial_contract_v1';
  var state = { blockedKeys: [], checking: false };

  function text(value) { return String(value == null ? '' : value).trim(); }
  function properties(item) {
    return item && item.properties && typeof item.properties === 'object' ? item.properties : {};
  }

  function isCanonical(item) {
    var productId = Number(item && item.product_id);
    var subtype = SOURCES[productId] || CARRIERS[productId];
    if (!subtype) return true;
    var props = properties(item);
    var strategy = text(props._carrier_strategy);
    var sourceId = Number(props._carrier_source_product_id);
    var carrierId = Number(props._carrier_product_id);
    var encoded = Number(props._carrier_encoded_quantity);
    var nativeTotal = Number(props._native_total_cents);
    var originalPrice = Number(item.original_price != null ? item.original_price : item.price);
    var quantity = Number(item.quantity);
    if (text(props._pricing_engine) !== 'true' || text(props._line_type) !== 'base' ||
        text(props._product_family) !== 'acrylic' || text(props._acrylic_subtype) !== subtype ||
        !text(props._calc_line_uid) || !text(props['Finished Size']) || !text(props.Pieces) ||
        !text(props.Turnaround) || encoded !== quantity || nativeTotal !== originalPrice * quantity ||
        sourceId !== Number(Object.keys(SOURCES).find(function (id) { return SOURCES[id] === subtype; }))) return false;
    if (SOURCES[productId]) {
      return strategy === CONFIGURED && carrierId === productId;
    }
    return strategy === DYNAMIC && text(props._carrier_contract) === CONTRACT && carrierId === productId;
  }

  function invalidGroups(items) {
    return (Array.isArray(items) ? items : []).filter(function (item) {
      return !isCanonical(item);
    }).map(function (item) {
      return { key: text(item.key), productId: Number(item.product_id) };
    }).filter(function (row) { return row.key; });
  }

  function setCheckoutBlocked(blocked) {
    if (typeof document === 'undefined') return;
    document.querySelectorAll('[name="checkout"], [href="/checkout"], form[action="/checkout"] button, form[action="/checkout"] input[type="submit"]').forEach(function (element) {
      if (blocked) {
        element.setAttribute('data-zug-acrylic-cart-blocked', 'true');
        element.setAttribute('aria-disabled', 'true');
        if ('disabled' in element) element.disabled = true;
      } else if (element.getAttribute('data-zug-acrylic-cart-blocked') === 'true') {
        element.removeAttribute('data-zug-acrylic-cart-blocked');
        element.removeAttribute('aria-disabled');
        if ('disabled' in element) element.disabled = false;
      }
    });
  }

  function renderBanner(groups) {
    if (typeof document === 'undefined') return;
    var banner = document.getElementById('zug-acrylic-cart-guard');
    if (!groups.length) {
      if (banner) banner.remove();
      return;
    }
    if (!banner) {
      banner = document.createElement('div');
      banner.id = 'zug-acrylic-cart-guard';
      banner.setAttribute('role', 'alert');
      banner.style.cssText = 'position:fixed;z-index:2147483646;left:16px;right:16px;top:16px;padding:16px;border:2px solid #b42318;border-radius:8px;background:#fff1f0;color:#5f140d;box-shadow:0 8px 30px rgba(0,0,0,.2);font:600 14px/1.4 system-ui,sans-serif';
      banner.innerHTML = '<span>This Acrylic item is missing its verified configuration and must be removed before checkout.</span> <button type="button" data-zug-acrylic-remove-invalid style="margin-left:12px;padding:8px 12px;border:0;border-radius:5px;background:#b42318;color:white;font-weight:700;cursor:pointer">Remove invalid Acrylic item</button>';
      document.body.appendChild(banner);
      banner.querySelector('[data-zug-acrylic-remove-invalid]').addEventListener('click', removeInvalid);
    }
  }

  function apply(groups) {
    state.blockedKeys = Array.from(new Set(groups.map(function (group) { return group.key; })));
    setCheckoutBlocked(state.blockedKeys.length > 0);
    renderBanner(groups);
  }

  function check() {
    if (typeof fetch === 'undefined' || state.checking) return Promise.resolve([]);
    state.checking = true;
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Acrylic Cart guard check failed.');
        return response.json();
      })
      .then(function (cart) {
        var groups = invalidGroups(cart.items);
        apply(groups);
        return groups;
      })
      .catch(function (error) {
        console.error('[ZUG][ACRYLIC] Cart guard failed closed', error);
        setCheckoutBlocked(state.blockedKeys.length > 0);
        return [];
      })
      .finally(function () { state.checking = false; });
  }

  function removeInvalid() {
    if (!state.blockedKeys.length) return Promise.resolve();
    var updates = {};
    state.blockedKeys.forEach(function (key) { updates[key] = 0; });
    return fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      if (!response.ok) throw new Error('Invalid Acrylic Cart removal failed.');
      return response.json();
    }).then(function () {
      apply([]);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    });
  }

  function blockCheckout(event) {
    if (!state.blockedKeys.length) return;
    var target = event.target && event.target.closest
      ? event.target.closest('[name="checkout"], [href="/checkout"], form[action="/checkout"]') : null;
    if (!target) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    renderBanner(state.blockedKeys.map(function (key) { return { key: key }; }));
  }

  function init() {
    if (typeof document === 'undefined') return;
    document.addEventListener('click', blockCheckout, true);
    document.addEventListener('submit', blockCheckout, true);
    document.addEventListener('cart:refresh', check);
    document.addEventListener('cart:change', check);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check);
    else check();
  }
  if (typeof window !== 'undefined') init();

  return { isCanonical: isCanonical, invalidGroups: invalidGroups, check: check, removeInvalid: removeInvalid };
});
